import { isPartnerRoleLocked, isPartnerRowUncertain, clearPartnerEditableResults } from "./partnerImportSave";
import { isImportRowSelected } from "../articleImportCompanyUnits";

const roleRow = (row, ledgerIds) => {
  const errors = { ...row.errors };
  delete errors.roles;
  if (!ledgerIds.length) errors.roles = "Caktoni Klient, Furnitor ose të dyja në tabelë.";
  return { ...row, ledgerIds, errors, saveResults: clearPartnerEditableResults(row) };
};
export function togglePartnerRole(row, ledgerId, checked) {
  if (![105, 302].includes(ledgerId) || isPartnerRoleLocked(row, ledgerId) || isPartnerRowUncertain(row)) return row;
  const ids = row.ledgerIds || [];
  if (ids.includes(ledgerId) === checked) return row;
  return roleRow(row, Object.freeze(checked ? [...ids, ledgerId].sort((a, b) => a - b) : ids.filter(id => id !== ledgerId)));
}
export async function assignPartnerRole(rows, selection, ledgerId, checked, { signal, onProgress } = {}) {
  if (![105, 302].includes(ledgerId)) throw new Error("Lloji i partnerit është i pavlefshëm.");
  const combinations = new Map();
  const result = new Array(rows.length);
  let changed = 0;
  for (let start = 0; start < rows.length; start += 5000) {
    if (signal?.aborted) throw new Error("Caktimi u anulua.");
    const end = Math.min(start + 5000, rows.length);
    for (let i = start; i < end; i++) {
      const row = rows[i]; const ids = row.ledgerIds || [];
      if (isPartnerRoleLocked(row, ledgerId) || isPartnerRowUncertain(row) || !isImportRowSelected(selection, row.id) || ids.includes(ledgerId) === checked) { result[i] = row; continue; }
      const key = ids.join(",");
      if (!combinations.has(key)) combinations.set(key, Object.freeze(checked ? [...ids, ledgerId].sort((a, b) => a - b) : ids.filter(id => id !== ledgerId)));
      result[i] = roleRow(row, combinations.get(key)); changed++;
    }
    onProgress?.(Math.round(end / rows.length * 100));
    if (end < rows.length) await new Promise(resolve => setTimeout(resolve, 0));
  }
  if (signal?.aborted) throw new Error("Caktimi u anulua.");
  return { rows: changed ? result : rows, changed };
}
